export default {
  title: 'Legal Notices',
  subtitle: 'Online service for test & Tagging of radio equipments for major events',
  presentation: 'The National Frequency Agency (ANFR) is a public institution placed under the Minister in charge of electronic communications. Its headquarters are located at 78, avenue du Général de Gaulle, 94700 MAISONS-ALFORT.',
  responsible: 'The person responsible for the publication of this online service, published by ANFR, is Mr Gilles Brégant as ANFR\'s legal representative.',
  editorial: 'The editorial staff is under the responsibility of the Directorate of Spectrum Control (DCS). ',
  online: 'This online service is produced by OCEANE CONSULTING DM located at 40 Rue de Bray, 35 510 Cesson-Sévigné',
  maintenance: 'The maintenance of this online service is provided by OCEANE CONSULTING DM located 40 Rue de Bray, 35 510 Cesson-Sévigné',
  host: 'This online service is hosted by ANFR and OVH Groupe SAS, located at 2, rue Kellermann, 59100 Roubaix.',
  publisher: 'Publisher identification :',
  address1: 'Agence Nationale des Fréquences (ANFR)',
  address2: '78 Avenue du général de Gaulle',
  zipcodeCity: '94700 Maisons-Alfort',
  siret: 'N°SIRET : 18005302700017',
  ape: 'Code APE : 8413 Z',
  information: 'You will find information relating to personal data and management of cookies in the General Conditions of Use of the service.'
}
